import {
  useCreateEMREvaluationDataForSiteMutation,
  useCreateEMREvaluationDataForSponsorMutation,
  useCreateNewEMRversionMutation,
  useGetAllEMREvalutionsMutation,
  useLazyGetSiteEMREvalutionsQuery,
  useLazyGetSponsorEMREvalutionsQuery,
  useNewEMRversionMutation,
  usePublishToETMFMutation,
  usePublishToISFMutation,
  useSiteSignMutation,
  useSponsorSignMutation,
  useUpdateEMREvaluationDataForSiteMutation,
  useUpdateEMREvaluationDataForSponsorMutation
} from 'src/services/EMREvaluation';

export const useEMREvaluation = () => {
  const [
    getAllEMREvaluation,
    {
      data: getAllEMREvaluationData,
      error: getAllEMREvaluationError,
      isError: getAllEMREvaluationIsError,
      isLoading: getAllEMREvaluationIsLoading,
      isSuccess: getAllEMREvaluationIsSuccess
    }
  ] = useGetAllEMREvalutionsMutation();

  const [
    getSiteEMREvaluationData,
    {
      data: emrSiteData,
      error: emrSiteDataError,
      isError: emrSiteDataIsError,
      isLoading: emrSiteDataIsLoading,
      isSuccess: emrSiteDataIsSuccess
    }
  ] = useLazyGetSiteEMREvalutionsQuery();

  const [
    getSponsorEMREvaluationData,
    {
      data: emrSponsorData,
      error: emrSponsorDataError,
      isError: emrSponsorDataIsError,
      isLoading: emrSponsorDataIsLoading,
      isSuccess: emrSponsorDataIsSuccess
    }
  ] = useLazyGetSponsorEMREvalutionsQuery();
  const [
    createSiteEMR,
    {
      data: createSiteEMRData,
      error: createSiteEMRError,
      isError: createSiteEMRIsError,
      isLoading: createSiteEMRIsLoading,
      isSuccess: createSiteEMRIsSuccess
    }
  ] = useCreateEMREvaluationDataForSiteMutation();
  const [
    updateSiteEMR,
    {
      data: updateSiteData,
      error: updateSiteError,
      isError: updateSiteIsError,
      isLoading: updateSiteIsLoading,
      isSuccess: updateSiteIsSuccess
    }
  ] = useUpdateEMREvaluationDataForSiteMutation();

  const [
    updateSponsorEMR,
    {
      data: updateSponsorEMRData,
      error: updateSponsorEMRError,
      isError: updateSponsorEMRIsError,
      isLoading: updateSponsorEMRIsLoading,
      isSuccess: updateSponsorEMRIsSuccess
    }
  ] = useUpdateEMREvaluationDataForSponsorMutation();

  const [
    siteSign,
    {
      data: siteSignData,
      error: siteSignError,
      isError: siteSignIsError,
      isLoading: siteSignIsLoading,
      isSuccess: siteSignIsSuccess
    }
  ] = useSiteSignMutation();

  const [
    sponsorSign,
    {
      data: sponsorSignData,
      error: sponsorSignError,
      isError: sponsorSignIsError,
      isLoading: sponsorSignIsLoading,
      isSuccess: sponsorSignIsSuccess
    }
  ] = useSponsorSignMutation();

  const [
    publishEMRDataToETMF,
    {
      data: publishEMRData,
      error: publishEMRError,
      isError: publishEMRIsError,
      isLoading: publishEMRIsLoading,
      isSuccess: publishEMRIsSuccess
    }
  ] = usePublishToETMFMutation();
  const [
    publishToISFEMRData,
    {
      data: publishISFEMR,
      error: publishISFEMRError,
      isError: publishISFEMRIsError,
      isLoading: publishISFEMRIsLoading,
      isSuccess: publishISFEMRIsSuccess
    }
  ] = usePublishToISFMutation();

  const [
    createNewEMRversion,
    {
      data: createNewEMRversionData,
      error: createNewEMRversionError,
      isError: createNewEMRversionIsError,
      isLoading: createNewEMRversionIsLoading,
      isSuccess: createNewEMRversionIsSuccess
    }
  ] = useCreateNewEMRversionMutation();
  const [
    createSponsorEMR,
    {
      data: createSponsorEMRData,
      error: createSponsorEMRError,
      isError: createSponsorEMRIsError,
      isLoading: createSponsorEMRIsLoading,
      isSuccess: createSponsorEMRIsSuccess
    }
  ] = useCreateEMREvaluationDataForSponsorMutation();
  const [
    newSponsorEMRversion,
    {
      data: newSponsorEMRversionData,
      error: newSponsorEMRversionError,
      isError: newSponsorEMRversionIsError,
      isLoading: newSponsorEMRversionIsLoading,
      isSuccess: newSponsorEMRversionIsSuccess
    }
  ] = useNewEMRversionMutation();

  return {
    getAllEMREvaluation,
    getAllEMREvaluationData,
    getAllEMREvaluationError,
    getAllEMREvaluationIsError,
    getAllEMREvaluationIsLoading,
    getAllEMREvaluationIsSuccess,
    emrSiteData,
    emrSiteDataError,
    emrSiteDataIsError,
    emrSiteDataIsLoading,
    emrSiteDataIsSuccess,
    emrSponsorData,
    emrSponsorDataError,
    emrSponsorDataIsError,
    emrSponsorDataIsLoading,
    emrSponsorDataIsSuccess,
    createSiteEMR,
    createSiteEMRData,
    createSiteEMRError,
    createSiteEMRIsError,
    createSiteEMRIsLoading,
    createSiteEMRIsSuccess,
    updateSiteData,
    updateSiteError,
    updateSiteIsError,
    updateSiteIsLoading,
    updateSiteIsSuccess,
    updateSponsorEMRData,
    updateSponsorEMRError,
    updateSponsorEMRIsError,
    updateSponsorEMRIsLoading,
    updateSponsorEMRIsSuccess,
    publishEMRData,
    publishEMRError,
    publishEMRIsError,
    publishEMRIsLoading,
    publishEMRIsSuccess,
    publishEMRDataToETMF,
    getSiteEMREvaluationData,
    getSponsorEMREvaluationData,
    updateSponsorEMR,
    updateSiteEMR,
    siteSign,
    siteSignData,
    siteSignError,
    siteSignIsError,
    siteSignIsLoading,
    siteSignIsSuccess,
    sponsorSign,
    sponsorSignData,
    sponsorSignError,
    sponsorSignIsError,
    sponsorSignIsLoading,
    sponsorSignIsSuccess,
    publishToISFEMRData,
    publishISFEMR,
    publishISFEMRError,
    publishISFEMRIsError,
    publishISFEMRIsLoading,
    publishISFEMRIsSuccess,
    createNewEMRversion,
    createNewEMRversionData,
    createNewEMRversionError,
    createNewEMRversionIsError,
    createNewEMRversionIsLoading,
    createNewEMRversionIsSuccess,
    createSponsorEMR,
    createSponsorEMRData,
    createSponsorEMRError,
    createSponsorEMRIsError,
    createSponsorEMRIsLoading,
    createSponsorEMRIsSuccess,
    newSponsorEMRversion,
    newSponsorEMRversionData,
    newSponsorEMRversionError,
    newSponsorEMRversionIsError,
    newSponsorEMRversionIsLoading,
    newSponsorEMRversionIsSuccess
  };
};
